module.exports = __webpack_public_path__ + "static/media/lock-dots.d5c303ce.svg";